import { parsePhoneNumber } from 'libphonenumber-js';

const formatPhoneNumber = number => {
  let formatted;
  if (number) {
    try {
      const phone = parsePhoneNumber(number, 'US');
      if (phone && phone.isValid()) {
        formatted = phone.format('NATIONAL');
        formatted = formatted.replace('(', '');
        formatted = formatted.replace(') ', '-');
      } else {
        formatted = number;
      }
    } catch (e) {
      formatted = number;
    }
  }
  return formatted;
};

const registrationPayload = values => {
  const phoneFormatted = formatPhoneNumber(values.Number);
  const mobileFormatted = formatPhoneNumber(values.Mobile || '');
  const faxFormatted = formatPhoneNumber(values.FaxNumber || '');

  const payload = {
    PersonId: 0,
    Name: {
      Prefix: values.Prefix ? values.Prefix : '',
      First: values.First,
      Middle: values.Middle ? values.Middle : '',
      Last: values.Last,
      Suffix: values.Suffix ? values.Suffix : '',
      Informal: values.Informal ? values.Informal : '',
    },
    Title: values.Title,
    Company: values.Company,
    Office: {
      StreetAddress1: values.StreetAddress1,
      StreetAddress2: values.StreetAddress2 !== 'STE ' ? values.StreetAddress2 : '',
      City: values.City,
      StateCode: values.StateCode,
      PostalCode: values.PostalCode,
      CountryCode: values.CountryCode,
      Country: values.Country,
      State: values.OfficeStateOther,
    },
    PoBox: {
      Number: values.PoBoxNumber ? values.PoBoxNumber : '',
      City: values.PoBoxCity ? values.PoBoxCity : '',
      StateCode: values.PoBoxStateCode ? values.PoBoxStateCode : '',
      PostalCode: values.PoBoxPostalCode ? values.PoBoxPostalCode : '',
      State: values.PoBoxOther,
    },
    Phone: {
      Number: phoneFormatted,
      Extension: values.Extension ? values.Extension : '',
    },
    Mobile: mobileFormatted,
    FaxNumber: faxFormatted,
    EmailAddress: values.EmailAddress,
    ConfirmEmailAddress: values.ConfirmEmailAddress,
    SecurityInformation: {
      Password: values.Password,
      SecurityQuestionId: values.SecurityQuestionId,
      SecurityAnswer: values.SecurityAnswer,
    },
    Comments: values.Comments,
  };
  return payload;
};
export default registrationPayload;
